export const environment = {
  production: true,
  identityUrl: 'https://cs-identity-api-qa.azurewebsites.net/',
  officeApiUrl: 'https://cs-backoffice-api-qa.azurewebsites.net/',
  nodeService: 'https://cs-identity-services-qa.azurewebsites.net/',
  applicationInsightsInstrumentationKey: '4174ec3b-4389-450b-a39e-bf68ba7947e1',
  firebaseConfig: {
    apiKey: 'AIzaSyAzWBAAyTSaROAYemYmQ5h3ISWgR4WdkII',
    authDomain: 'clovebuild-25f5e.firebaseapp.com',
    projectId: 'clovebuild-25f5e',
    storageBucket: 'clovebuild-25f5e.firebasestorage.app',
    messagingSenderId: '381804877100',
    appId: '1:381804877100:web:af27d4ccf0e903cb8d4889',
    measurementId: 'G-YS8C4HP27J',
    vapidKey:
      'BKHVxZiaIa4BhEc_QbaI-CqYQsSjbMiD_rwyt6TOdZgGgi-SM9nb60sXWQPJkbdw2VDvb6xA6a9Z9surJi_98cg'
  }
};
